import Usuarios from "../excel/reports/Usuarios";
import Archivos from "../excel/reports/Archivos";
import Sentencias from "./reports/Sentencias";

export default async function getReportExcel(report: number, data: any, extra?: object){
    switch(report){     
        case 1: return Archivos(data.data);
        case 2: return Usuarios(data.data);
        case 3: return Sentencias(data.rows);
        default: throw new Error("El reporte seleccionado no existe", {cause: 404});
    }
}